export default __webpack_public_path__ + "static/media/DAIF_Data_Screen1_in-end.62d3f7be.jpg";